import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=080a713b&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=tsx&"
export * from "./taskDetail.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a713b",
  null
  
)

export default component.exports